module.exports['en-us'] = require('./en-US.js')
module.exports['es-419'] = require('./es-419.js')
module.exports['es-co'] = require('./es-CO.js')
module.exports['es-mx'] = require('./es-MX.js')
module.exports['ja-jp'] = require('./ja-JP.js')
module.exports['pt-br'] = require('./pt-BR.js')
module.exports['zh-cn'] = require('./zh-CN.js')